import React, { useEffect } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import { isEmpty } from "lodash";
import useEvents from "../../hooks/useEvents.js";
import useOrchestrator from "../../hooks/useOrchestrator.js";
const OPT_IN_AA_COLLECTION_POINT = "web_sr_aa";
const OPT_IN_AA_INIT_EVENT = "CAPLA_EVENT_direct-marketing-component_OPT_IN_AA_INIT";
const OPT_IN_AA_RESOLVED_EVENT = "CAPLA_EVENT_direct-marketing-component_OPT_IN_AA_RESOLVED";
const OptInAANeetiTracker = () => {
    const { grumble } = useEvents();
    const orchestrator = useOrchestrator();
    const { Component, isLoading, error } = useRemoteComponent({
        type: "capla",
        project: "direct-marketing",
        service: "rendering-service",
        path: "/OptInAAOrchestrator",
        options: {
            timeout: 5000
        }
    });
    useEffect(() => {
        if (!orchestrator)
            return;
        return orchestrator.on(OPT_IN_AA_RESOLVED_EVENT, (result) => {
            grumble("OptInAA orchestrator: RESOLVED", { result });
        });
    }, [orchestrator, grumble]);
    useEffect(() => {
        if (isLoading || error || !orchestrator)
            return;
        orchestrator.publish(OPT_IN_AA_INIT_EVENT, {
            collectionPoint: OPT_IN_AA_COLLECTION_POINT
        });
        grumble("OptInAA orchestrator: INIT published", {
            collectionPoint: OPT_IN_AA_COLLECTION_POINT
        });
    }, [isLoading, error, orchestrator, grumble]);
    useEffect(() => {
        if (!isLoading && error && !isEmpty(error)) {
            grumble("Remote component error: OptInAA orchestrator on SR page", { error: error.toString() });
        }
    }, [isLoading, error, grumble]);
    useEffect(() => {
        if (!isLoading && !error) {
            grumble("OptInAA orchestrator: remote component mounted");
        }
    }, [isLoading, error, grumble]);
    if (isLoading || error) {
        return null;
    }
    return React.createElement(Component, null);
};
export default OptInAANeetiTracker;
